import {make} from '@/editor/editorUtility.js';
import {aws_bucket} from '@/shared/helpers.js';
// import lessonPool from '@/lesson/lessonPool.vue';
// import lessonPoolQuiz from '@/lesson/lessonPoolQuiz.vue';

// base classes for school content container
const schoolDefault = ['w-full', 'mx-auto'];

function getClasses(obj) {
	let classArray = [];
	if (obj.class) {
		if (obj.stretched !== undefined && obj.stretched === true) {
			classArray = obj.class.join(' ');
		} else {
			classArray = schoolDefault.concat(obj.class.filter((item) => schoolDefault.indexOf(item) < 0)).join(' ');
		}
		return classArray;
	} else {
		return [];
	}
}

export function convertCamelStylesToString(obj, objKey = 'style') {
	// console.log('obj styles: ', obj);
	if (!obj) return null;
	
	if (obj.style || obj.styles) {
		let str = '';
		if (Object.keys(obj[objKey]).length !== 0) {
			for (let key in obj[objKey]) {
				str += `${key.replace(/[A-Z]/g, '-$&').toLowerCase()}: ${obj[objKey][key].replace(/[A-Z]/g, '-$&').toLowerCase()}; `;
			}
		}
		return str;
	} else {
		return null;
	}
}

function makeTable(obj) {
	let out = `
<div class="mt-8 flex flex-col">
  <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
    <div class="inline-block min-w-full py-2 align-middle">
      <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg mx-1">
        <table class="min-w-full divide-y divide-gray-300">
          <thead class="bg-gray-50">
            <tr>`;
	obj.data.content[0].forEach(key => out += '<th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 lg:pl-8">' + key + '</th>');
	
	out += `</tr>
          </thead>
          <tbody class="divide-y divide-gray-200 bg-white">`;
	
	obj.data.content.slice(1).forEach(row => {
		out += '<tr>';
		row.forEach(key => out += '<td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 lg:pl-8">' + key + '</td>');
		out += '</tr>';
	});
	out += `</tbody>
        </table>
      </div>
    </div>
  </div>
</div>`;
	return out;
}

function makeColumns(obj) {
	let out = `<div class="grid grid-cols-${obj.data.cols.length} gap-3 -my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8 mt-8">`;
	obj.data.cols.forEach(col => {
		out += `<div class="md:col-span-1 col-span-${obj.data.cols.length} rounded">`;
		col.blocks.forEach(block => {
			let function_name = 'make' + _.upperFirst(block.type);
			out += makeParagraph(block);
		});
		out += '</div>';
		
	});
	
	out += '</div>';
	return out;
	
}

function makeHeader(obj) {
	let output = '';
	switch (obj.data.level) {
		case 1 :
			return output = `<h${obj.data.level} class="${getClasses(obj.data)} m_bottom my-5 ai-header" style="${convertCamelStylesToString(obj.data)}">${obj.data.text}</h${obj.data.level}>`;
			break;
		case 2 :
			return output = `<h${obj.data.level} class="${getClasses(obj.data)} m_bottom my-5 ai-header" style="${convertCamelStylesToString(obj.data)}">${obj.data.text}</h${obj.data.level}>`;
			break;
		case 3 :
			return output = `<h${obj.data.level} class="${getClasses(obj.data)} m_bottom my-5 ai-header" style="${convertCamelStylesToString(obj.data)}">${obj.data.text}</h${obj.data.level}>`;
			break;
		case 4 :
			return output = `<h${obj.data.level} class="${getClasses(obj.data)} m_bottom my-5 ai-header" style="${convertCamelStylesToString(obj.data)}">${obj.data.text}</h${obj.data.level}>`;
			break;
		case 5 :
			return output = `<h${obj.data.level} class="${getClasses(obj.data)} m_bottom my-5 ai-header" style="${convertCamelStylesToString(obj.data)}">${obj.data.text}</h${obj.data.level}>`;
			break;
		case 6 :
			return output = `<h${obj.data.level} class="${getClasses(obj.data)} m_bottom my-5 ai-header" style="${convertCamelStylesToString(obj.data)}">${obj.data.text}</h${obj.data.level}>`;
			break;
	}
}


function makeImage(obj) {
	// console.log('image', obj, getClasses(obj.data.container), getClasses(obj.data.imageBlock));
	const caption = obj.data.captionBlock ? obj.data.captionBlock.text : obj.data.caption;
	let file_url = obj.data.file.url.includes('https://platform.productland.ru/img') ?
		obj.data.file.url.replace('https://platform.productland.ru/img/', aws_bucket) : obj.data.file.url;
	let container_classes = obj.data?.container?.class ? getClasses(obj.data.container) : '';
	let container_styles = obj.data.container ? convertCamelStylesToString(obj.data.container) : '';
	let image_classes = obj.data?.imageBlock?.class ? (getClasses(obj.data.imageBlock)) : 'ringed rounded shadow-little';
	let image_styles = obj.data.imageBlock ? convertCamelStylesToString(obj.data.imageBlock) : '';
	let caption_classes = obj.data?.captionBlock?.class ? (getClasses(obj.data.captionBlock)) : 'text_14 opacity-60 font-semibold';
	let caption_styles = obj.data.captionBlock ? convertCamelStylesToString(obj.data.captionBlock) : '';
	
	return `<div class="object-contain"><div class="${container_classes} m_bottom" style="${container_styles}">
            <img src="${file_url}" alt="image" class="${image_classes}" style="${image_styles}" />
            <span class="${caption_classes}" style="${caption_styles}">${caption}</span>
          </div></div>`;
}

function makeParagraph(obj) {
	let classes = getClasses(obj.data);
	let decoration = classes.length ? classes.replace('cdx-block', '') : null;
	
	return `<p class="${decoration} m_bottom my-5" style="${convertCamelStylesToString(obj.data)}">${obj.data.text}</p>`;
}

function makeList(obj) {
	let list = '';
	let list_styles = '';
	if (obj.data.lineSpace) {
		list = obj.data.items.map(item => `<li style="padding-bottom: ${obj.data.lineSpace}px;">${item}</li>`);
		list_styles = obj.data.style ? convertCamelStylesToString(obj.data, 'style') : '';
	} else {
		list = obj.data.items.map(item => `<li>${item}</li>`);
		list_styles = obj.data.style === 'ordered' ? 'list-style: decimal;' : 'list-style: disc;';
	}

	// console.log('list', obj, getClasses(obj.data), obj.data.wrapper_class);
	let wrapper_classes = obj.data?.wrapper_class ? obj.data.wrapper_class.join(' ') : '';
	let main_classes = obj.data?.class ? getClasses(obj.data) : '';
	let main_styles = obj.data.styles ? convertCamelStylesToString(obj.data, 'styles') : '';
	
	let icon_decoration = obj.data.side_icon === 'Camera_intro' ? 'mr-1 mt-1' : 'mr-6';
	let list_position = obj.data.position ? obj.data.position : 'outside';
	
	if (obj.data.side_icon) {
		return `
    <div class="${main_classes} my-5" style="${main_styles}">
      <div class="${icon_decoration}" style="margin-top: 2px">
        ${obj.data.title_icon}
      </div>
      <div>
        <span class="my-2">${obj.data.title}</span>
        <ul class="${wrapper_classes}" style="${list_styles} list-style-position: ${list_position}">${list.join('')} </ul>
      </div>
    </div>`;
	} else {
		let decoration = main_classes.length ? main_classes.replaceAll('flex', '') : null;

		return `
      <div class="${decoration} my-5 ml-4" style="${main_styles}">
        <ul class="${wrapper_classes}" style="${list_styles} list-style-position: ${list_position}">${list.join('')} </ul>
      </div>`;
	}
}


function makePersonality(obj) {
	// console.log('obj', obj);
	
	const name = obj.data.name.text ? obj.data.name.text : '';
	const company = obj.data.company.text ? obj.data.company.text : '';
	const description = obj.data.description.text ? obj.data.description.text : '';
	const uid = obj.data.uid.text ? obj.data.uid.text : '';
	const photo = obj.data.photo.url ? aws_bucket + obj.data.photo.url.replace('/img/', '') : '/img/empty_user.jpeg';
	const wrapperClass = obj.data.stretched ? obj.data.wrapper.class.join(' ') : schoolDefault.concat(obj.data.wrapper.class.filter((item) => schoolDefault.indexOf(item) < 0)).join(' ');
	
	return `
    <div class="${wrapperClass}" style="${convertCamelStylesToString(obj.data.wrapper)}">
      <div class="${obj.data.imageWrapper.class.join(' ')}" style="${convertCamelStylesToString(obj.data.imageWrapper)}">
        <img src="${photo}" alt="userImage" class="${obj.data.photo.class.join(' ')}" style="${convertCamelStylesToString(obj.data.photo)}"/>
      </div>
      <section class="${obj.data.text.class.join(' ')}">
        <div class="${obj.data.company.class.join(' ')}" style="${convertCamelStylesToString(obj.data.company)}">${company}</div>
        <div class="${obj.data.name.class.join(' ')}" style="${convertCamelStylesToString(obj.data.name)}">${name}</div>
        <div class="${obj.data.description.class.join(' ')}" style="${convertCamelStylesToString(obj.data.description)}">${description}</div>
        <div class="${obj.data.uid.class.join(' ')}" style="${convertCamelStylesToString(obj.data.uid)}">${uid}</div>
      </section>
    </div>
  `;
}

function escapeHtml(text) {
	var map = {
		'&': '&amp;',
		'<': '&lt;',
		'>': '&gt;',
		'"': '&quot;',
		'\'': '&#039;'
	};
	
	return text.replace(/[&<>"']/g, function (m) {
		return map[m];
	});
}

function makeCode(obj) {
	// console.log(146, "makeCode");
	const settings = ['bg-gray-200', 'text-xs', 'font-mono', 'my-4', 'p-6', 'rounded', 'overflow-auto'];
	let classArray = schoolDefault.concat(settings.filter((item) => schoolDefault.indexOf(item) < 0)).join(' ');
	const code = escapeHtml(obj.data.code);
	
	return `
<section class="${classArray}">
<pre>
<code>
${code}
</code>
</pre>
</section>`;
}

function makeQuote(obj) {
	return `<div class="w-2/3 block my-4 bg-green-100 p-6 rounded">
              <blockquote>
                <p class="text-lg font-serif mb-4">
                  ${obj.data.text}
                </p>
              </blockquote>
              <p class="my-2 text-xs">- ${obj.data.caption}</p>
            </div>`;
}

function makeDelimiter(obj) {

}

function makeWarning(obj) {
	return `<section class="bg-red-100 w-full text-center py-12 rounded">
              <div class="">
                <h3><span><i class="fas fa-exclamation"></i></span>${obj.data.title}</h3>
                <p>${obj.data.message}</p>
              </div>
            </section>`;
}

function makeChecklist(obj) {
	const list = obj.data.items.map(item => {
		return `
        <div class="_1checkbox">
          <span class="_1checkbox_round"></span>
          ${item.text}
        </div>`;
	});
	
	return `
      <section class="">
        <div class="">
          <div class="">
            <div class="">
              ${list.join('')}
            </div>
          </div>
        </div>
      </section>`;
}

function makeEmbed(obj) {
	const caption = obj.data.caption ? `
      <div class="">
        <p class=""> ${obj.data.caption}</p>
      </div>` : '';
	
	return `
      <section class="">
        <div class="">
          <div class="">
            <iframe width="730" height="415" src="${obj.data.embed}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
          ${caption}
        </div>
      </section>`;
}

function makeVideo(obj) {
	if (obj.data.url) {
		return `<div style="margin: 0 auto;" class="m_bottom xl:w-2/3">
            <video src="${obj.data.url}" controls controlsList="nodownload" poster="${obj.data.cover_url}"/>
          </div>`;
	}
	return '';
}

function makeFile(obj) {
	// console.log('file render', obj);
	if (obj.data.url) {
		return `<a href="${obj.data.url}" target="_blank"> <div class="fileEditor m_bottom xl:w-2/3">
                <div class="wrap_icon">
                    <svg version="1.0" height="70px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 452.000000 452.000000" preserveAspectRatio="xMidYMid meet"> <g transform="translate(0.000000,452.000000) scale(0.100000,-0.100000)"> <path d="M1041 4120 c-148 -53 -258 -186 -282 -340 -6 -42 -9 -603 -7 -1565 l3 -1500 26 -63 c48 -113 135 -203 239 -245 l55 -22 1170 -3 c1164 -2 1169 -2 1232 19 116 38 216 135 265 257 l23 57 3 1028 c2 727 -1 1040 -8 1070 -10 37 -83 113 -638 670 -345 346 -639 635 -654 643 -23 12 -135 14 -700 14 -642 -1 -675 -2 -727 -20z m1219 -683 c0 -468 3 -495 63 -596 42 -69 106 -126 187 -165 l65 -31 453 -3 452 -3 0 -942 c0 -927 0 -943 -20 -975 -40 -65 23 -62 -1200 -62 -1223 0 -1160 -3 -1200 62 -20 33 -20 46 -20 1538 0 1491 0 1505 20 1538 38 62 29 61 643 62 l557 0 0 -423z m704 -515 c-349 -3 -351 -2 -398 61 -20 27 -21 41 -24 355 l-3 327 371 -370 370 -370 -316 -3z"/> <path d="M2192 2430 c-18 -11 -41 -34 -52 -52 -19 -31 -20 -51 -20 -353 l0 -320 -78 78 c-86 86 -132 109 -189 97 -48 -11 -78 -33 -97 -73 -20 -43 -20 -78 -2 -120 16 -37 407 -427 451 -451 28 -14 7 -15 -285 -16 -294 0 -317 -1 -347 -20 -45 -27 -65 -62 -65 -114 0 -59 26 -102 77 -126 40 -19 64 -20 673 -20 556 0 636 2 672 16 51 21 82 69 82 130 0 52 -20 87 -65 114 -30 19 -53 20 -347 20 -292 1 -313 2 -285 16 44 24 435 414 451 451 49 113 -55 227 -171 187 -24 -8 -68 -42 -117 -91 l-78 -78 0 320 c0 302 -1 322 -20 353 -42 68 -124 91 -188 52z"/> </g> </svg>
                </div>
                <div class="wrap_input">
                    ${obj.data.des}
                </div>
          </div></a>`;
	}
	return '';
}

function makeBtn(obj) {
	// console.log('MakeBTN', obj);
	if (obj.data.parentId) {
		return `<div class="btnEditor m_bottom xl:w-2/3 w-full mx-auto" ">
                        <div class="next_btn d_none" style="${obj.data.style}" data-elId="${obj.data.elId}" data-parentId="${obj.data.parentId}" onclick="open_content(this, this.dataset.elid)">
                            ${obj.data.des}
                        </div>
            </div>`;
	}
	return `<div class="btnEditor m_bottom xl:w-2/3 w-full mx-auto" ">
                        <div class="next_btn" style="${obj.data.style}" data-elId="${obj.data.elId}" onclick="open_content(this, this.dataset.elid)">
                            ${obj.data.des}
                        </div>
            </div>`;
}

function makeHTML(obj) {
	
	// console.log('HTML code render 256', obj);
	if (obj.data.js) {
		let js = document.createElement('script');
		js.text = obj.data.js;
		document.body.appendChild(js);
	}
	if (obj.data.html) {
		return obj.data.html;
	}
}

function makeQuiz(obj) {
	// console.log(obj);
	// let quiz = make('div', ['bg-red-100', 'p-4'], {id: 'quiz'});
	//     quiz.innerHTML = obj.data.intro;
	// // return quiz;
	// return `
	//   <span>${obj.data.intro}</span>
	//   <img src="/img/uploads/${obj.data.img}" />
	//   <span>${obj.data.comments[0].text}</span>
	//   <span>${obj.data.options[0].text}</span>
	// `
	// console.log('lessonPoll', newComponent);
	
	// return lessonPool.render ;
	
	// this.simple_Question.input = obj;
	// this.simple_Question.show = true;
	// return `
	// <div class="w-4/5 mx-auto p-3 my-4" >
	
	//   <img src="/img/uploads/+${obj.data.img}" class="max-h-40 mx-auto mb-10">
	
	//   <h1 class="mt-4 mb-8 mx-2 text-center text-gray-100" >${obj.data.intro}</h1>
// return obj.data.intro;
	
	// </div>
	
	// `;
}

function makeSurvey(obj) {
	console.log(obj);
	// this.simple_Question.input = obj;
	// this.simple_Question.show = true;
	return '';
}

function makeAction(obj) {
	let buttonBlock = document.createElement('div');
	// for (var i = 0; i < obj.data.buttonBlock.length; i++) {
	//   console.log('ergergergmpmhpo5wmw]tohmobr');
	
	//   let span = document.createElement('span');
	//   span.innerHTML = obj.data.buttonBlock[i].text;
	//   span.classList.add(obj.data.buttonBlock[i].class);
	//   for (let key in obj.data.buttonBlock[i].style) {
	//     // console.log('sss', obj.data.buttonBlock[i].style[key]);
	
	//     span.style[key] = obj.data.buttonBlock[i].style[key]
	//   }
	//   buttonBlock.appendChild(span);
	// }
	// console.log('makeAction(obj)', obj.data.buttonBlock.toArray().length);
	let out = `
    <div class="${getClasses(obj.data.output)} m_bottom" style="${styleString(obj.data.output.style)}">
      <span class="${classString(obj.data.title.class)}" style="${styleString(obj.data.title.style)}">${obj.data.title.text}</span>
      <span class="${classString(obj.data.subtitle.class)}" style="${styleString(obj.data.subtitle.style)}">${obj.data.subtitle.text}</span>
      <span class="${classString(obj.data.description.class)}" style="${styleString(obj.data.description.style)}">${obj.data.description.text}</span>
      <div>`;
	for (let btn in obj.data.buttonBlock) {
// console.log(obj.data.buttonBlock[btn]);
		let textColor = obj.data.buttonBlock[btn].style.color ? obj.data.buttonBlock[btn].style.color : '';
		let fonColor = obj.data.buttonBlock[btn].style.backgroundColor ? obj.data.buttonBlock[btn].style.backgroundColor : '';
		
		out += `<span class="${classString(obj.data.buttonBlock[btn].class)}" style="${styleString(obj.data.buttonBlock[btn].style)}" onMouseOver="this.style.color = '${fonColor}', this.style.backgroundColor = '${textColor}'" onMouseOut="this.style.color = '${textColor}', this.style.backgroundColor = '${fonColor}'">${obj.data.buttonBlock[btn].text}</span> `;
	}
	out += '</div></div>';
	
	// out.appendChild(buttonBlock);
	return out;
}

function classString(arr) {
	// let str = '';
	// for (var i = arr.length - 1; i >= 0; i--) {
	//   str+= arr[i]+' ';
	// }
	return arr.join(' '); // make it inline
}

function styleString(ob) {
	let str = '';
	for (let key in ob) {
		let value = ob[key];
		if (key.split('C').length > 1) {
			let segments = key.split('C');
			str += `${segments[0]}-c${segments[1]}: ${value}; `;
		} else {
			str += `${key}: ${value}; `;
		}
	}
	// console.log(str);
	
	return str;
	
}

export function htmlOutput(data) {
	if (JSON.parse(data).length == 0) {
		return; // empty schema, no object with blocks inside so return
	}
	let html_code = '';
	// console.log(JSON.parse(data).blocks, 368, "htmlOutput");
	JSON.parse(data).blocks.map(obj => {
		// console.log(obj.type);
		switch (obj.type) {
			case 'paragraph':
				html_code += makeParagraph(obj);
				break;
			case 'action':
				html_code += makeAction(obj);
				break;
			case 'image':
				// console.log(obj.data.file.url);
				html_code += makeImage(obj);
				break;
			case 'header':
				html_code += makeHeader(obj);
				break;
			case 'table':
				html_code += makeTable(obj);
				break;
			case 'columns':
				html_code += makeColumns(obj);
				break;
			case 'list':
				html_code += makeList(obj);
				break;
			case 'personality':
				html_code += makePersonality(obj);
				break;
			case 'code':
				html_code += makeCode(obj);
				break;
			case 'embed':
				html_code += makeEmbed(obj);
				break;
			case 'quote':
				html_code += makeQuote(obj);
				break;
			case 'delimiter':
				html_code += makeDelimiter(obj);
				break;
			case 'warning':
				html_code += makeWarning(obj);
				break;
			case 'checklist':
				html_code += makeChecklist(obj);
				break;
			case 'quiz':
				// return obj.data;
				// console.log('rververvw');
				
				// this.simple_Question.input = obj;
				// this.simple_Question.show = true;
				html_code += makeQuiz(obj);
				// html_code += makeQuiz(obj);
				break;
			case 'survey':
				html_code += makeSurvey(obj);
				break;
			case 'video':
				html_code += makeVideo(obj);
				break;
			case 'file':
				html_code += makeFile(obj);
				break;
			case 'button':
				html_code += makeBtn(obj);
				break;
			case 'html':
				html_code += makeHTML(obj);
				break;
		}
	});
	return html_code;
}
